<template>
  <div class="auth-layout">
    <div class="auth-visual">
      <div class="visual-content">
        <div class="brand-logo" @click="handleLogoClick">
          <img :src="require('../assets/images/ipipbright.png')" alt="IpipBright logo" />
        </div>
        <div class="visual-text">
          <h1 class="gradient-text">{{ i18n[currentLanguage].brandSlogan }}</h1>
          <p>{{ i18n[currentLanguage].brandTagline }}</p>
        </div>

        <!-- 中间动态描述文案区块 -->
        <div class="dynamic-proxy-desc">
          <div class="desc-box">
            <a-icon type="api" class="desc-icon" />
            <div class="desc-text">
              <h3>{{ i18n[currentLanguage].dynamicTitle }}</h3>
              <p>{{ i18n[currentLanguage].dynamicContent }}</p>
            </div>
          </div>
          
          <div class="desc-box desc-box-alt">
            <a-icon type="node-index" class="desc-icon icon-alt" />
            <div class="desc-text">
              <h3>{{ i18n[currentLanguage].dynamicTitle2 }}</h3>
              <p>{{ i18n[currentLanguage].dynamicContent2 }}</p>
            </div>
          </div>
        </div>

        <div class="feature-list">
          <div class="f-item">
            <div class="f-icon"><a-icon type="safety-certificate" /></div>
            <div class="f-text">
              <h4>{{ i18n[currentLanguage].featureSecurity }}</h4>
              <p>{{ i18n[currentLanguage].featureSecurityDesc }}</p>
            </div>
          </div>
          <div class="f-item">
            <div class="f-icon"><a-icon type="swap" /></div>
            <div class="f-text">
              <h4>{{ i18n[currentLanguage].featureRotation }}</h4>
              <p>{{ i18n[currentLanguage].featureRotationDesc }}</p>
            </div>
          </div>
          <div class="f-item">
            <div class="f-icon"><a-icon type="global" /></div>
            <div class="f-text">
              <h4>{{ i18n[currentLanguage].featureRegions }}</h4>
              <p>{{ i18n[currentLanguage].featureRegionsDesc }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="glow-orb orb-1"></div>
      <div class="glow-orb orb-2"></div>
    </div>

    <div class="auth-form-panel">
      <div class="top-actions">
        <div class="lang-switch" @click="changeLanguage(currentLanguage === 'zh' ? 'en' : 'zh')">
          <a-icon type="global" /> {{ currentLanguage.toUpperCase() }}
        </div>
      </div>

      <div class="form-container">
        <div class="form-header">
          <h2>{{ i18n[currentLanguage].registerTitle }}</h2>
          <p>{{ i18n[currentLanguage].pleaseRegister }}</p>
        </div>

        <a-form ref="form" :form="form" :rules="formRules" class="custom-form">
          <a-form-item prop="username">
            <a-input v-decorator="['username', { initialValue: '' }]" size="large" :placeholder="i18n[currentLanguage].username" class="modern-input">
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-item>

          <a-form-item prop="password">
            <a-input-password v-decorator="['password', { initialValue: '' }]" size="large" :placeholder="i18n[currentLanguage].password" class="modern-input">
              <a-icon slot="prefix" type="lock" />
            </a-input-password>
          </a-form-item>

          <a-form-item prop="passwordcheck">
            <a-input-password v-decorator="['passwordcheck', { initialValue: '' }]" size="large" :placeholder="i18n[currentLanguage].confirmPassword" class="modern-input">
              <a-icon slot="prefix" type="lock" />
            </a-input-password>
          </a-form-item>

          <a-form-item prop="code">
            <div class="code-wrapper">
              <a-input v-decorator="['code', { initialValue: '' }]" size="large" :placeholder="i18n[currentLanguage].verificationCode" class="modern-input" style="flex: 1;">
                <a-icon slot="prefix" type="scan" />
              </a-input>
              <div class="code-image-box" @click="getCodeNew">
                <img :src="codeUrl" alt="captcha" v-if="codeUrl"/>
                <span v-else style="font-size: 0.9rem;">Loading...</span>
              </div>
            </div>
          </a-form-item>

          <a-form-item prop="userType" style="display: none;"><a-input v-decorator="['userType', { initialValue: 'ipipbright' }]"></a-input></a-form-item>
          <a-form-item prop="invitation" style="display: none;"><a-input v-decorator="['invitation', { initialValue: invitationCode }]"></a-input></a-form-item>
          <a-form-item prop="rePassword" style="display: none;"><a-input v-decorator="['rePassword', { initialValue: '' }]"></a-input></a-form-item>

          <div class="form-options">
            <a-form-item prop="checked" style="margin-bottom: 0;">
              <a-checkbox v-decorator="['checked', { initialValue: false, valuePropName: 'checked' }]" class="custom-checkbox">
                {{ i18n[currentLanguage].agreeTerms }}
              </a-checkbox>
            </a-form-item>
          </div>

          <a-button type="primary" size="large" block @click="handleSubmit" class="modern-btn">
            {{ i18n[currentLanguage].register }} <a-icon type="user-add" />
          </a-button>

          <div class="auth-footer">
            <span>{{ i18n[currentLanguage].hasAccount }}</span>
            <a href="/login">{{ i18n[currentLanguage].loginNow }}</a>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterView',
  created() {
    // 初始化时提取邀请码，在组件创建时就计算好
    let searchParams = new URLSearchParams(window.location.search);
    this.invitationCode = searchParams.get('invitation') || '';
  },
  data() {
    return {
      form: this.$form.createForm(this),
      codeUrl: '',
      currentLanguage: 'en',
      invitationCode: '', // 邀请码将在created钩子中初始化
      i18n: {
        zh: {
          registerTitle: '创建账号',
          pleaseRegister: '请填写以下信息完成注册',
          username: '账号',
          password: '密码',
          confirmPassword: '确认密码',
          phone: '手机号',
          email: '邮箱',
          verificationCode: '验证码',
          agreeTerms: '我已阅读并同意服务条款',
          register: '注册',
          hasAccount: '已有账号？',
          loginNow: '立即登录',
          registerSuccess: '注册成功',
          registerFailed: '注册失败',
          passwordRequired: '密码必填',
          usernameRequired: '账号必填',
          phoneRequired: '手机号必填',
          emailRequired: '邮箱必填',
          codeRequired: '验证码必填',
          confirmPasswordRequired: '确认密码必填',
          passwordMismatch: '两次输入的密码不一致',
          termsRequired: '请同意服务条款',
          requestFailed: '注册请求失败',
          getCodeFailed: '获取验证码失败',
          // 左侧品牌区域国际化 - 动态IP代理网站
          brandSlogan: '动态IP代理，全球网络加速',
          featureSecurity: '安全可靠',
          featureSecurityDesc: '企业级加密技术，保障数据安全',
          featureRotation: '智能轮换',
          featureRotationDesc: '自动IP轮换，防止被封锁',
          featureRegions: '全球覆盖',
          featureRegionsDesc: '覆盖200+国家和地区',
          featurePerformance: '高速稳定',
          featurePerformanceDesc: '99.9% uptime，低延迟连接',
          brandTagline: '选择ipipbright，畅享全球网络资源',
          statUsers: '活跃用户',
          statUptime: '服务可用性',
          statNodes: '优质IP节点',
          dynamicTitle: '高质量动态住宅代理',
          dynamicContent: '依托于业务大数据积累和IP库留存算法，能够为您提供指定应用场景下经过质量筛选的优质IP，支持灵活的定制和快速的网络环境切换。',
          dynamicTitle2: '千万级真实设备IP',
          dynamicContent2: '由全球各地的真实宽带设备组成，IP每日更新并智能轮换，极速连接保障您在数据采集和多账号业务上的高可用性。'
        },
        en: {
          registerTitle: 'Create Account',
          pleaseRegister: 'Please fill in the information below to register',
          username: 'Username',
          password: 'Password',
          confirmPassword: 'Confirm Password',
          phone: 'Phone',
          email: 'Email',
          verificationCode: 'Verification Code',
          agreeTerms: 'I have read and agree to the Terms of Service',
          register: 'Register',
          hasAccount: 'Already have an account?',
          loginNow: 'Login Now',
          registerSuccess: 'Registration Success',
          registerFailed: 'Registration Failed',
          passwordRequired: 'Password is required',
          usernameRequired: 'Username is required',
          phoneRequired: 'Phone is required',
          emailRequired: 'Email is required',
          codeRequired: 'Verification code is required',
          confirmPasswordRequired: 'Confirm password is required',
          passwordMismatch: 'Passwords do not match',
          termsRequired: 'Please agree to the Terms of Service',
          requestFailed: 'Registration request failed',
          getCodeFailed: 'Failed to get verification code',
          // 左侧品牌区域国际化 - Dynamic IP Proxy Website
          brandSlogan: 'Dynamic IP Proxy, Global Network Acceleration',
          featureSecurity: 'Secure & Reliable',
          featureSecurityDesc: 'Enterprise-level encryption technology',
          featureRotation: 'Smart Rotation',
          featureRotationDesc: 'Automatic IP rotation to prevent blocking',
          featureRegions: 'Global Coverage',
          featureRegionsDesc: 'Covering 200+ countries and regions',
          featurePerformance: 'High Speed & Stable',
          featurePerformanceDesc: '99.9% uptime, low latency connection',
          brandTagline: 'Choose ipipbright, Enjoy Global Network Resources',
          statUsers: 'Active Users',
          statUptime: 'Service Availability',
          statNodes: 'Premium IP Nodes',
          dynamicTitle: 'High-Quality Dynamic Proxies',
          dynamicContent: 'Based on big data and IP retention algorithms, we provide quality-filtered IPs for specific scenarios, supporting flexible customization and fast network switching.',
          dynamicTitle2: 'Millions of Real Device IPs',
          dynamicContent2: 'Consists of real broadband devices worldwide. IPs are updated daily and intelligently rotated, ensuring high availability for data scraping and multi-account operations.'
        }
      },
      formRules: {
        username: [{ required: true, message: '账号必填', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
        passwordcheck: [{ required: true, message: '确认密码必填', trigger: 'blur' }],
        code: [{ required: true, message: '验证码必填', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.getCodeNew();
  },
  methods: {
    handleLogoClick() {
      this.$router.push('/');
    },
    changeLanguage(language) {
      this.currentLanguage = language;
      this.updateFormRules();
    },
    updateFormRules() {
      this.formRules = {
        username: [{ required: true, message: this.i18n[this.currentLanguage].usernameRequired, trigger: 'blur' }],
        password: [{ required: true, message: this.i18n[this.currentLanguage].passwordRequired, trigger: 'blur' }],
        passwordcheck: [{ required: true, message: this.i18n[this.currentLanguage].confirmPasswordRequired, trigger: 'blur' }],
        code: [{ required: true, message: this.i18n[this.currentLanguage].codeRequired, trigger: 'blur' }]
      };
    },
    getCodeNew() {
      this.$request.get('/auth/captcha', { responseType: 'arraybuffer' })
        .then(res => {
          if (res.status === 200) {
            const base64 = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            this.codeUrl = `data:image/png;base64,${base64}`;
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err);
          this.$message.error(this.i18n[this.currentLanguage].getCodeFailed);
        });
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.password !== values.passwordcheck) {
            this.$message.warning(this.i18n[this.currentLanguage].passwordMismatch);
            return;
          }
          if (!values.checked) {
            this.$message.warning(this.i18n[this.currentLanguage].termsRequired);
            return;
          }

          const visitLogId = localStorage.getItem('PROMO_VISIT_LOG_ID'); // 获取日志ID
          
          // 提交注册请求，使用正确的字段名
          this.$request.post('/auth/register', {
            username: values.username,
            password: values.password,
            passwordcheck: values.passwordcheck,
            code: values.code,
            invitation: values.invitation,
            visitLogId: visitLogId,
            userType: values.userType,
            rePassword: '' // 保持空字符串，根据提供的参数要求
          })
            .then(res => {
              if (res.data.code === 200) {
                // 注册成功，清理战场
                localStorage.removeItem('PROMO_VISIT_LOG_ID');
                sessionStorage.removeItem(`VISIT_LOGGED_${values.invitation}`);
                this.$message.success(this.i18n[this.currentLanguage].registerSuccess);
                this.$router.push('/login');
              } else {
                this.$message.warning(this.i18n[this.currentLanguage].registerFailed);
                this.getCodeNew();
              }
            })
            .catch(err => {
              console.error('注册请求失败:', err);
              this.$message.error(this.i18n[this.currentLanguage].requestFailed);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }
.auth-layout {
  display: flex;
  min-height: 100vh;
  background: #2d2c28;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* Left Visual Panel */
.auth-visual {
  flex: 1;
  max-width: 45%;
  background: #1f1e1b;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 60px 50px;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.visual-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.brand-logo {
  cursor: pointer;
  margin-bottom: 60px;
}

.brand-logo img {
  height: 50px;
  transition: transform 0.3s ease;
}

.brand-logo:hover img {
  transform: scale(1.05);
}

.visual-text {
  margin-bottom: 60px;
}

.visual-text h1 {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 15px;
  color: #fff;
}

.gradient-text {
  background: linear-gradient(135deg, #1581c6 0%, #00ea90 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.visual-text p {
  font-size: 1.2rem;
  color: #aaa;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: auto;
}

.f-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.f-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(21, 129, 198, 0.1);
  color: #1581c6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.f-text h4 {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 5px 0;
}

.f-text p {
  color: #888;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.4;
}

/* Dynamic Proxy Desc Section */
.dynamic-proxy-desc {
  margin: 40px 0;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.desc-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.desc-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #1581c6, #00ea90);
}

.desc-box-alt::before {
  background: linear-gradient(to bottom, #00ea90, #1581c6);
}

.desc-box:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(21, 129, 198, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.desc-icon {
  font-size: 32px;
  color: #00ea90;
  background: rgba(0, 234, 144, 0.1);
  padding: 12px;
  border-radius: 12px;
}

.icon-alt {
  color: #1581c6;
  background: rgba(21, 129, 198, 0.1);
}

.desc-text h3 {
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.desc-text p {
  color: #aaa;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

/* Decorative Orbs */
.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  z-index: 1;
  opacity: 0.15;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: #1581c6;
  top: -100px;
  left: -100px;
  animation: float 10s infinite ease-in-out alternate;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: #00ea90;
  bottom: -150px;
  right: -100px;
  animation: float 12s infinite ease-in-out alternate-reverse;
}

@keyframes float {
  0% { transform: translate(0, 0); }
  100% { transform: translate(30px, 30px); }
}

/* Right Form Panel */
.auth-form-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #2d2c28;
}

.top-actions {
  display: flex;
  justify-content: flex-end;
  padding: 30px 40px;
}

.lang-switch {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #aaa;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  background: #33342e;
  border: 1px solid rgba(255,255,255,0.05);
  transition: all 0.3s ease;
}

.lang-switch:hover {
  color: #fff;
  background: #1581c6;
  border-color: #1581c6;
}

.form-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
}

.custom-form {
  width: 100%;
  max-width: 420px;
}

.form-header {
  width: 100%;
  max-width: 420px;
  margin-bottom: 40px;
}

.form-header h2 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
}

.form-header p {
  color: #888;
  font-size: 1.1rem;
  margin: 0;
}

/* Input Overrides */
:deep(.ant-input), :deep(.ant-input-password .ant-input) {
  height: 56px !important;
  background: #33342e !important;
  border: 1px solid rgba(255,255,255,0.08) !important;
  border-radius: 12px !important;
  color: #fff !important;
  font-size: 16px !important;
  padding-left: 45px !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

:deep(.ant-input:focus), :deep(.ant-input:hover),
:deep(.ant-input-password:hover .ant-input),
:deep(.ant-input-password:focus-within .ant-input) {
  border-color: #1581c6 !important;
  background: #3a3935 !important;
}

:deep(.ant-input-prefix) {
  left: 15px !important;
  color: #888 !important;
  font-size: 18px !important;
}

:deep(.ant-input:focus ~ .ant-input-prefix) {
  color: #1581c6 !important;
}

:deep(.ant-input-password-icon) {
  color: #888 !important;
}

:deep(.ant-form-item) {
  margin-bottom: 24px;
}

.form-options {
  margin-bottom: 30px;
}

:deep(.ant-checkbox-wrapper) {
  color: #aaa;
}

:deep(.ant-checkbox-inner) {
  background-color: #33342e;
  border-color: rgba(255,255,255,0.2);
}

:deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #1581c6;
  border-color: #1581c6;
}

.modern-btn {
  height: 56px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  background: #1581c6;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  box-shadow: 0 4px 15px rgba(21,129,198,0.3);
  transition: all 0.3s ease;
}

.modern-btn:hover {
  background: #126ba5;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(21,129,198,0.4);
}

.auth-footer {
  margin-top: 30px;
  text-align: center;
  color: #888;
  font-size: 1rem;
}

.auth-footer a {
  color: #1581c6;
  font-weight: 600;
  margin-left: 5px;
  text-decoration: none;
  transition: color 0.3s;
}

.auth-footer a:hover {
  color: #00ea90;
}

/* Verification Code specific */
.code-wrapper {
  display: flex;
  gap: 15px;
}

.code-image-box {
  width: 140px;
  height: 56px;
  border-radius: 12px;
  background: #33342e;
  border: 1px solid rgba(255,255,255,0.08);
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  transition: border-color 0.3s;
}

.code-image-box:hover {
  border-color: #1581c6;
}

.code-image-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Responsive */
@media (max-width: 992px) {
  .auth-visual {
    display: none;
  }
  .auth-form-panel {
    background: #1f1e1b;
  }
}
</style>